import { initialAuthState } from '@/store';
import { APP_CONFIG, AuthActionType, StorageKey } from '@/types';
export const authReducer = (state, action) => {
    switch (action.type) {
        case AuthActionType.RESET_AUTH: {
            return initialAuthState;
        }
        case AuthActionType.SET_USER_INVITATION: {
            const { payload } = action;
            return Object.assign(Object.assign({}, state), { userInvitation: Object.assign(Object.assign(Object.assign({}, state.userInvitation), payload), { meta: Object.assign(Object.assign({}, state.userInvitation.meta), payload.meta) }) });
        }
        case AuthActionType.SET_COMPLETED_USER_PHASE_EVENTS: {
            const { payload } = action;
            const existingEvents = JSON.parse(localStorage.getItem(StorageKey.COMPLETED_USER_PHASE_EVENTS) || '[]');
            const updatedEvents = [payload, ...existingEvents];
            localStorage.setItem(StorageKey.COMPLETED_USER_PHASE_EVENTS, JSON.stringify(updatedEvents));
            const newSchedule = state.schedule.map((event) => {
                if (existingEvents.some((e) => e.eventId === event.id)) {
                    return Object.assign(Object.assign({}, event), { completed: true });
                }
                return event;
            });
            return Object.assign(Object.assign({}, state), { schedule: newSchedule });
        }
        case AuthActionType.SET_USER_DETAILS: {
            return Object.assign(Object.assign({}, state), { user: action.payload });
        }
        case AuthActionType.SET_CURRENT_ROUTE: {
            return Object.assign(Object.assign({}, state), { currentRoute: action.payload });
        }
        case AuthActionType.SET_CURRENT_USER_PHASE: {
            const { payload } = action;
            const currentUserPhaseSegment = state.segments.find((segment) => segment.id === (payload === null || payload === void 0 ? void 0 : payload.segment_id));
            return Object.assign(Object.assign({}, state), { currentUserPhaseEvent: payload, currentUserPhaseSegment: currentUserPhaseSegment || initialAuthState.currentUserPhaseSegment });
        }
        case AuthActionType.SET_USER_PHASE: {
            const { events = [], id, segments = [] } = action.payload;
            const existingEvents = JSON.parse(localStorage.getItem(StorageKey.COMPLETED_USER_PHASE_EVENTS) || '[]');
            // Create a Set of completed event IDs from payload for O(1) lookup
            const payloadCompletedEventIds = new Set();
            const newSchedule = [];
            // Single loop to process events and collect completed IDs
            for (const event of events) {
                if (event.completed) {
                    payloadCompletedEventIds.add(event.id);
                    newSchedule.push(event);
                }
                else {
                    // Check if event is completed in localStorage
                    const isCompletedInStorage = existingEvents.some((e) => e.eventId === event.id);
                    newSchedule.push(Object.assign(Object.assign({}, event), { completed: isCompletedInStorage }));
                }
            }
            // Remove events from localStorage that are already completed in the payload
            const filteredExistingEvents = existingEvents.filter((existingEvent) => !payloadCompletedEventIds.has(existingEvent.eventId));
            // Update localStorage with the filtered events
            localStorage.setItem(StorageKey.COMPLETED_USER_PHASE_EVENTS, JSON.stringify(filteredExistingEvents));
            return Object.assign(Object.assign({}, state), { currentUserPhase: id, schedule: newSchedule, segments });
        }
        case AuthActionType.SET_IDENTITY_PROVIDERS: {
            return Object.assign(Object.assign({}, state), { identityProviders: action.payload });
        }
        case AuthActionType.SET_USER_PHASE_EVENT_DONE: {
            const { payload: eventId } = action;
            const event = state.schedule.find((x) => x.meta.find((m) => m.value === eventId)) ||
                state.currentUserPhaseEvent;
            if (event.type.toLowerCase() ===
                APP_CONFIG.COMPONENTS.ScheduleEventType.QUESTIONNAIRE.toLowerCase()) {
                const newEvent = Object.assign(Object.assign({}, event), { completed: true });
                const schedule = state.schedule.map((item) => (item.id === (newEvent === null || newEvent === void 0 ? void 0 : newEvent.id) ? newEvent : item));
                return Object.assign(Object.assign({}, state), { schedule });
            }
            return state;
        }
        default:
            throw new Error();
    }
};
